import { ApiLambdalerAuthHeaderSchema } from '@eigtech/lambdaler-api-gateway-types';
import { z } from 'zod';
import { InspectionCornSchema, InspectionEntityCornSchema } from '../base.js';
export const GetDocumentUploadUrlApiSchema = {
    params: z.object({
        entityId: InspectionEntityCornSchema,
        inspectionId: InspectionCornSchema,
    }),
    query: z.object({}),
    headers: ApiLambdalerAuthHeaderSchema.required({ requestActor: true }),
    response: z.object({
        fields: z.record(z.string(), z.string()),
        url: z.string(),
    }),
};
export const GetDocumentUploadUrlRequestSchema = GetDocumentUploadUrlApiSchema.params
    .merge(GetDocumentUploadUrlApiSchema.headers)
    .merge(GetDocumentUploadUrlApiSchema.query);
